import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Seguidores',
  fields: {
    name: 'Nome',
    subscribed: 'Subscrito',
    followed: 'Seguido',
    phone: 'Telefone',
    recent_order: 'Encomenda Recente',
    total_orders: 'Total de Encomendas',
    birthday: 'Aniversário',
    google_review: 'Avaliação Google',
    marketing_subscription_source: 'Subscrito via',
    loyalty_points: 'Fidelidade',
  },
  empty_list: 'Ainda sem clientes',
  yes: 'Sim',
  no: 'Não',
  buttons: {
    import: 'Importar',
    export: 'Exportar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
  labels: {
    followed_since_date: 'Desde {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
